import { type CSSProperties } from "react";

import clsx from "clsx";

interface SwitchProps {
  size?: "large" | "small" | "medium" | "x-small";
  value: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
  id?: string;
  className?: string;
  labelClassname?: string;
  style?: CSSProperties & { [key: string]: string };
}

export const Switch = ({
  value,
  onChange,
  id,
  disabled = false,
  size = "medium",
  className,
  labelClassname,
  style,
}: SwitchProps) => {
  const htmlId = `check--${id}`;

  return (
    <label
      className={clsx(`custom-switch-${size}`, labelClassname)}
      htmlFor={htmlId}
      style={style}
    >
      <input
        className="hidden"
        disabled={disabled}
        type="checkbox"
        checked={value}
        onChange={({ target }) => onChange(target.checked)}
        id={htmlId}
      />
      <span className={clsx("slider", disabled && "disabled", className)} />
    </label>
  );
};
